import React, { useState } from 'react'
import { connect } from 'react-redux';
import { Card, Col, Row, Button, Tag, Statistic, Progress, Alert } from 'antd'
import moment from 'moment'
import axios from 'axios';
import {SERVER_PATH, axiosConfig1 } from '../actions/common';
import { setCbt } from '../actions/cbt';

function shuffle(array) {
    return array.sort(() => Math.random() - 0.5);
}
  const alph = {
    0:'A',
    1:'B',
    2:'C',
    3:'D'
}
const TestCards = (props)=> {
    
    const [isloading, setisloading] = useState(false)
    let {data, mid, sid} = props || []
    const setAnswer = (options, answer) =>{
        let opt = []
        let random_num_pos = Math.floor(Math.random() * 4)
        let random_num_alp = alph[random_num_pos]
        let ops_obj = '--'
        let oth_obj = []
        options.forEach(element  => {
            let opt_details = element.split("::::")
            if(opt_details[0] === answer){
                ops_obj = opt_details[1]
            }else if(opt_details[0] !== answer){
                oth_obj.push(opt_details[1])
            }
        })
    
        for (let index = 0; index < Object.keys(alph).length; index++) {
            const letter = alph[index];
            let obj = {}
            if (letter === random_num_alp) {
                obj.alp = letter
                obj.text = ops_obj
            } else {
                obj.alp = letter
                obj.text = oth_obj[0]
                oth_obj.shift()
                // delete[oth_obj[0]]
            } 
            opt.push(obj) 
        }
       
        return [opt, random_num_alp]
      }
    const startExam = (d) =>{
        //check if question was saved
        if(typeof parseInt(d.testid) === "number" 
        && parseInt(d.testid) > 0){
            let arr = {}
            arr['testid'] = d.testid
            arr['data'] = d 
            setCbt(arr)
            window.open(process.env.PUBLIC_URL+`/test/${d.testid}`)
        }else{
            let ques = JSON.parse(d.cbtquestions)
            let starttime = new Date().getTime() / (1000 * 60)
            let duration = parseInt(d.testtime) > 0  ? parseInt(d.testtime) : 0
            let endtime = starttime + parseInt(duration)
            //get all ids match to instructions
            let q_ar = {}
            let q_ar_answer_arr = {}
            let q_ar_answer = {}
            Object.keys(ques).forEach(p=>{
                let w = ques[p]
                let d = w.instruction || 'Choose the correct option'
                q_ar[p] = d 
                let o = w.options.split("::::::")
                let a = w.answer
                let pos = setAnswer(o, a)
                q_ar_answer_arr[p] = pos[0]
                q_ar_answer[p] = pos[1]
            })
            let q_ar_intr = {}
            Object.keys(q_ar).forEach(p=>{
                let inst = q_ar[p]
                if(q_ar_intr.hasOwnProperty(inst)){
                    q_ar_intr[inst].push(p)
                }else{
                    q_ar_intr[inst] = [] 
                    q_ar_intr[inst].push(p)
                }
            })
            //shuffle array
            let q_ar_intr_shuffle = {}
            Object.keys(q_ar_intr).forEach(p=>{
                let d = q_ar_intr[p]
                q_ar_intr_shuffle[p] = shuffle(d)
            })
            let q_ar_answers = [q_ar_answer, q_ar_answer_arr]
            

            let fd = new FormData();
            fd.append('questions', JSON.stringify(q_ar_intr_shuffle));
            fd.append('answers', JSON.stringify(q_ar_answers));
            fd.append('answer', JSON.stringify({}));
            fd.append('cbtexamid', d.id);
            fd.append('schoolid', sid);
            fd.append('studentid', mid);
            fd.append('starttime', starttime);
            fd.append('endtime', endtime);
            fd.append('duration', duration);
            fd.append('cat', 'cbt');
            fd.append('table', 'cbttests');  
            setisloading(true)
            axios
            .post(SERVER_PATH, fd, axiosConfig1)
            .then(res => {
                    setisloading(false)
                    if(parseInt(res.data.data.testid) > 0){
                        let arr = {}
                        arr['testid'] = res.data.data.testid
                        arr['data'] = res.data.data 
                        setCbt(arr)
                        window.open(process.env.PUBLIC_URL+`/test/${res.data.data.testid}`)
                    }
            })
            .catch(err => {
                    setisloading(false)
                    Alert()
            })
        }
    
    }
    const tryExam = (d) =>{
        //check if question was saved
            let ques = JSON.parse(d.cbtquestions)
            let starttime = new Date().getTime() / (1000 * 60)
            let duration = parseInt(d.testtime) > 0  ? parseInt(d.testtime) : 0
            let endtime = starttime + parseInt(duration)
            //get all ids match to instructions
            let q_ar = {}
            let q_ar_answer_arr = {}
            let q_ar_answer = {}
            Object.keys(ques).forEach(p=>{
                let w = ques[p]
                let d = w.instruction || 'Choose the correct option'
                q_ar[p] = d 
                let o = w.options.split("::::::")
                let a = w.answer
                let pos = setAnswer(o, a)
                q_ar_answer_arr[p] = pos[0]
                q_ar_answer[p] = pos[1]
            })
            let q_ar_intr = {}
            Object.keys(q_ar).forEach(p=>{
                let inst = q_ar[p]
                if(q_ar_intr.hasOwnProperty(inst)){
                    q_ar_intr[inst].push(p)
                }else{
                    q_ar_intr[inst] = [] 
                    q_ar_intr[inst].push(p)
                }
            })
            //shuffle array
            let q_ar_intr_shuffle = {}
            Object.keys(q_ar_intr).forEach(p=>{
                let d = q_ar_intr[p]
                q_ar_intr_shuffle[p] = shuffle(d)
            })
            let q_ar_answers = [q_ar_answer, q_ar_answer_arr]
            let fd = new FormData();
            fd.append('questions', JSON.stringify(q_ar_intr_shuffle));
            fd.append('answers', JSON.stringify(q_ar_answers));
            fd.append('answer', JSON.stringify({}));
            fd.append('cbtexamid', d.id);
            fd.append('schoolid', sid);
            fd.append('studentid', mid);
            fd.append('starttime', starttime);
            fd.append('endtime', endtime);
            fd.append('duration', duration);
            fd.append('cat', 'cbt');
            fd.append('table', 'cbttests');  
            setisloading(true)
            axios
            .post(SERVER_PATH, fd, axiosConfig1)
            .then(res => {
                    setisloading(false)
                    if(parseInt(res.data.data.testid) > 0){
                        let arr = {}
                        arr['testid'] = res.data.data.testid
                        arr['data'] = res.data.data 
                        console.log(arr)
                        setCbt(arr)
                        //window.open(process.env.PUBLIC_URL+`/test/${res.data.data.testid}`)
                    }
            })
            .catch(err => {
                    setisloading(false)
            })
    
    }
  return (
    <div className="site-card-wrapper">
    <Row className="text-left">
        {
            data.map((prop, ind)=>{
                let {examname, answer, teststart, testend, status, noq, is_multiple, duration, testtime, score, starttime, endtime } = prop || ''
                duration = parseInt(duration) > 0 ? parseInt(duration) : 0
                let sc = score || 0
                let a = answer || null
                let a1 = typeof a === 'string' && a.length > 0 ? JSON.parse(a) : ''
                let states = typeof a1 === 'object' ?  Object.keys(a1).length  : 0 
                let pers = noq > 0 ? (states/noq) * 100 : 0

                return <Card key={ind}
                        style={{ width: 320, marginBlock: 3 }} 
                        title={examname} 
                        bordered={true}
                        actions={[
                            status == 0 ? <Button 
                                type="primary"
                                disabled={
                                    new Date(teststart) > new Date() &&
                                    new Date(testend) < new Date() ?
                                    true : false
                                 }
                                 onClick={()=>startExam(prop)}
                                danger>
                                Start test
                              </Button>:
                               status == 2 ? <Button 
                               type="info"
                               disabled={
                                   new Date(teststart) > new Date() &&
                                   new Date(testend) < new Date() ?
                                   true : false
                                }
                                onClick={()=>startExam(prop)}
                               info>
                               Continue
                             </Button>:'',
                              is_multiple != 2 ? <Button 
                              type="primary"
                               onClick={()=>tryExam(prop)}
                              danger>
                              Try Again
                            </Button>:'',
                             
                            ]}
                        >
                        <Row>
                            <Col xs={12}>
                            <Statistic
                                title="Score"
                                value={sc > 0 ? sc * 100 : 0}
                                precision={1}
                                valueStyle={{ color: sc < 70 ? '#cf1322' :'green' }}
                                suffix="%"
                            />
                            </Col>
                            <Col xs={12}>
                                <Progress 
                                type="circle" 
                                percent={Number(pers).toFixed(1)} 
                                width={80} 
                                strokeColor={{
                                    '0%': 'red',
                                    '50%': 'yellow',
                                    '80%': 'green',
                                    '100%': 'lemon',
                                  }}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>Duration</Col>
                            <Col xs={12} className="text-right">
                                <b>{`${testtime}`}</b>
                            </Col>
                        </Row>
                        <Row>
                            <Col>Time Spent</Col>
                            <Col xs={12} className="text-right">
                                <b>{`${testtime - duration}`}</b>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>Questions</Col>
                            <Col xs={12} className="text-right"><b>{noq}</b></Col>
                        </Row>
                        <Row>
                            <Col xs={12}>Test Opens</Col>
                            <Col xs={12} style={{fontSize:'10px'}} className="text-right"><b>{moment(teststart).format('MMM Do YYYY, h:mm:ss a')}</b>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>Test Closes</Col>
                            <Col xs={12} style={{fontSize:'10px'}} className="text-right"><b>{moment(testend).format('MMM Do YYYY, h:mm:ss a')}</b></Col>
                        </Row>
                        <Row>
                            <Col xs={12}>Status</Col>
                            <Col xs={12} className="text-right">
                            {status == 1 ? <Tag color="green">Completed</Tag>:''}
                            {status == 2 ? <Tag color="purple">Ongoing</Tag>:''}
                            {status == 0 ? <Tag color="blue">Active</Tag>:''}
                            {status == '' ? <Tag color="blue">Active</Tag>:''}
                            </Col>
                        </Row>
                        
                    </Card>
            })
        }
    </Row>
  </div>
  )
}

TestCards.propTypes = {}
const mapStateToProps = (state) => ({

})
const mapDispatchToProps = {setCbt}
export default connect(mapStateToProps, mapDispatchToProps)(TestCards)
